export function formatMoneyInput(value) {
  if (isNaN(value)) {
    return '';
  }

  // Format the number as currency
  const formattedValue = Number(value).toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
  });
  return formattedValue;
}
